import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "top-role-player" }
const _hoisted_2 = { class: "top-player-title" }
const _hoisted_3 = { class: "d-flex align-center pa-3" }
const _hoisted_4 = { class: "teammate-profile-container" }
const _hoisted_5 = { class: "stats-container" }
const _hoisted_6 = { class: "rating-value" }
const _hoisted_7 = { class: "winrate-container" }
const _hoisted_8 = { class: "games-count" }
const _hoisted_9 = { class: "d-flex align-center pa-3" }
const _hoisted_10 = { class: "no-data-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PreviewLink = _resolveComponent("PreviewLink")!
  const _component_TeammateProfile = _resolveComponent("TeammateProfile")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_WinrateDisplay = _resolveComponent("WinrateDisplay")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.$t('stats.topPlayerTitle')) + " ", 1),
      (_ctx.displayRole)
        ? (_openBlock(), _createBlock(_component_PreviewLink, {
            key: 0,
            target: _ctx.role
          }, null, 8, ["target"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.topPlayer)
      ? (_openBlock(), _createBlock(_component_v_card, {
          key: 0,
          class: "top-player-card",
          onClick: _ctx.navigateToPlayerStats
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "crown-icon mr-2" }, "🏆", -1)),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_TeammateProfile, {
                  teammateID: _ctx.topPlayer.userID
                }, null, 8, ["teammateID"])
              ]),
              _createVNode(_component_v_spacer),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.topPlayer.rating), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_WinrateDisplay, {
                    winrate: _ctx.topPlayer.winrate.toFixed(2)
                  }, null, 8, ["winrate"])
                ]),
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('stats.gamesPlayed', { count: _ctx.topPlayer.gamesCount })), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["onClick"]))
      : (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
            key: 1,
            type: "image",
            class: "top-player-skeleton"
          }))
        : (_openBlock(), _createBlock(_component_v_card, {
            key: 2,
            class: "top-player-card no-data-card"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "no-data-icon mr-2" }, "🏆", -1)),
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('stats.noTopPlayerData')), 1)
              ])
            ]),
            _: 1
          }))
  ]))
}